<div class="card">
    <div class="card-header">
        <div class="card-title mb-0">Withdraw</div>
    </div>
    <div class="card-body">
        <form #form="ngForm" (ngSubmit)="form.valid && submit()">  
        <div class="mb-3">
            <label for="name" class="form-label">Amount to Withdraw</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.withdraw" name="withdraw" #withdraw="ngModel" required />
            <div *ngIf="form.submitted && withdraw.invalid" class="invalid-feedback">
                <div *ngIf="withdraw.errors.required">Amount to Withdraw is required</div>
            </div>
        </div>
        <hr/>

        <div class="mb-3">
            <label for="name" class="form-label">Payout From</label>
            <ng-select
                #select
                class="modal-appended-select"
                bindLabel="title" 
                bindValue="id" 
                [items]="banks"
                [clearable]="true"
                [placeholder]="'Select Bank'"
                appendTo="body"
                dropdownPosition="auto"
                [(ngModel)]="data.withdraw_from_account" name="withdraw_from_account" #withdraw_from_account="ngModel" required >
                <ng-template ng-label-tmp let-item="item">
                    <div>{{item.title}} ({{item.balance}})</div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <div>{{item.title}} ({{item.balance}})</div>
                </ng-template>
            </ng-select>
            <div *ngIf="form.submitted && withdraw_from_account.invalid" class="invalid-feedback">
                <div *ngIf="withdraw_from_account.errors.required">Payout From is required</div>
            </div>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-row justify-content-between align-items-start">
                <label for="name" class="form-label">Payout To Account</label>
            </div>
            
        </div>
        <div class="mb-3">
            <label for="name" class="form-label">Bank Name</label>
            <input type="text" class="form-control" [(ngModel)]="data.withdraw_bank" name="withdraw_bank" #withdraw_bank="ngModel" required />
            <div *ngIf="form.submitted && withdraw_bank.invalid" class="invalid-feedback">
                <div *ngIf="withdraw_bank.errors.required">Bank Name is required</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="name" class="form-label">Account Number</label>
            <input type="text" class="form-control" [(ngModel)]="data.withdraw_account_no" name="withdraw_account_no" #withdraw_account_no="ngModel" required />
            <div *ngIf="form.submitted && withdraw_account_no.invalid" class="invalid-feedback">
                <div *ngIf="withdraw_account_no.errors.required">Account Number is required</div>
            </div>
        </div>
        <button class="btn btn-success w-100 btn-sm" type="submit" [disabled]="is_loading_function">Withdraw</button>
        <button class="btn btn-danger w-100 btn-sm mt-3" (click)="close()" type="button" [disabled]="is_loading_function">Close</button>
        </form>
    </div>
</div>
